const REQUESTER_HIGHLIGHTS = [
  { bg: 'rgba(37, 99, 235, 0.12)', hover: 'rgba(37, 99, 235, 0.20)', requesterBg: 'rgba(37, 99, 235, 0.24)', requesterHover: 'rgba(37, 99, 235, 0.30)', accent: '#2563eb' },
  { bg: 'rgba(217, 119, 6, 0.14)', hover: 'rgba(217, 119, 6, 0.22)', requesterBg: 'rgba(217, 119, 6, 0.26)', requesterHover: 'rgba(217, 119, 6, 0.32)', accent: '#d97706' },
  { bg: 'rgba(147, 51, 234, 0.12)', hover: 'rgba(147, 51, 234, 0.20)', requesterBg: 'rgba(147, 51, 234, 0.24)', requesterHover: 'rgba(147, 51, 234, 0.30)', accent: '#9333ea' },
  { bg: 'rgba(220, 38, 38, 0.11)', hover: 'rgba(220, 38, 38, 0.19)', requesterBg: 'rgba(220, 38, 38, 0.22)', requesterHover: 'rgba(220, 38, 38, 0.28)', accent: '#dc2626' },
  { bg: 'rgba(8, 145, 178, 0.12)', hover: 'rgba(8, 145, 178, 0.20)', requesterBg: 'rgba(8, 145, 178, 0.24)', requesterHover: 'rgba(8, 145, 178, 0.30)', accent: '#0891b2' },
  { bg: 'rgba(219, 39, 119, 0.11)', hover: 'rgba(219, 39, 119, 0.19)', requesterBg: 'rgba(219, 39, 119, 0.22)', requesterHover: 'rgba(219, 39, 119, 0.28)', accent: '#db2777' },
  { bg: 'rgba(79, 70, 229, 0.12)', hover: 'rgba(79, 70, 229, 0.20)', requesterBg: 'rgba(79, 70, 229, 0.24)', requesterHover: 'rgba(79, 70, 229, 0.30)', accent: '#4f46e5' },
  { bg: 'rgba(180, 83, 9, 0.13)', hover: 'rgba(180, 83, 9, 0.21)', requesterBg: 'rgba(180, 83, 9, 0.25)', requesterHover: 'rgba(180, 83, 9, 0.31)', accent: '#b45309' },
];

const hashRequester = (requester) => {
  return requester.split('').reduce((hash, char) => {
    return ((hash << 5) - hash + char.charCodeAt(0)) | 0;
  }, 0);
};

const toRequesterStyle = (color) => ({
  '--transfer-requester-row-bg': color.bg,
  '--transfer-requester-row-hover-bg': color.hover,
  '--transfer-requester-cell-bg': color.requesterBg,
  '--transfer-requester-cell-hover-bg': color.requesterHover,
  '--transfer-requester-row-accent': color.accent,
});

export const getTransferRequester = (transfer) => {
  return (
    transfer?.requester ||
    transfer?.requestedBy ||
    transfer?.requestBy ||
    transfer?.createdBy ||
    transfer?.userName ||
    transfer?.username ||
    'Unknown'
  );
};

export const getRequesterHighlightStyle = (requester) => {
  const normalizedRequester = (requester || 'Unknown').trim().toLowerCase();
  const colorIndex = Math.abs(hashRequester(normalizedRequester)) % REQUESTER_HIGHLIGHTS.length;
  return toRequesterStyle(REQUESTER_HIGHLIGHTS[colorIndex]);
};

export const getRequesterHighlightStyleByIndex = (index) => {
  return toRequesterStyle(REQUESTER_HIGHLIGHTS[index % REQUESTER_HIGHLIGHTS.length]);
};
